var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4486 5.56364C11.4311 5.49378 11.4305 5.42076 11.4468 5.35062C11.4631 5.28047 11.4959 5.21523 11.5424 5.16028C11.589 5.10533 11.648 5.06227 11.7145 5.03465C11.781 5.00704 11.8531 4.99567 11.9249 5.00148C15.6551 5.3013 18.5886 8.4228 18.5886 12.231C18.5886 16.2374 15.3414 19.4847 11.335 19.4847C10.0647 19.4852 8.81666 19.152 7.7157 18.5184C6.61475 17.8849 5.69955 16.9732 5.06173 15.8747C5.02624 15.8138 5.00543 15.7455 5.00097 15.6751C4.99651 15.6048 5.00852 15.5344 5.03604 15.4695C5.06356 15.4046 5.10583 15.347 5.15951 15.3013C5.21318 15.2556 5.27677 15.223 5.34523 15.2062C6.31179 14.9686 7.49111 14.5872 8.56103 13.9948C9.63276 13.4006 10.5618 12.6124 11.0805 11.5751C12.1165 9.5036 11.8427 7.13527 11.4486 5.56364Z",
    fill: "#4700A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.f590ffe1b6aef95f57de724fee0694ca.svg";
export { ForwardRef as ReactComponent };